import {Component, OnInit, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {Sepa} from '../../dto/sepa';
import {toDateString} from '../../providers/app-date-adapter';
import {RevolutService} from '../services/revolut.service';
import {RevolutTransactionLeg} from '../../dto/revolut-transaction-leg';
import {Customer} from '../../dto/customer';
import {CulpaStatsModel} from '../../models/culpa-stats-model';

@Component({
  selector: 'app-revolut',
  templateUrl: './revolut.component.html',
  styleUrls: ['./revolut.component.css']
})
export class RevolutComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private revolutService: RevolutService,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;
  @ViewChild(MatTableGeneratorComponent, { static: true }) tableNotLinked: MatTableGeneratorComponent;


  ngOnInit() {
    this.tableNotLinked.filters.someAdditionalData = 'notlinked';
    this.table.filters.str = this.route.snapshot.queryParamMap.get( 'search' );
    this.tableNotLinked.filters.str = this.route.snapshot.queryParamMap.get( 'searchNotLinked' );

    this.isStatsLoading = true;
    this.revolutService.getCulpaStats().subscribe(result => {
      this.culpaStats = result;
      this.isStatsLoading = false;
    });

  }



  isStatsLoading = false;
  culpaStats: CulpaStatsModel = null;

  dataSource = new MultiCrudDataSource( this.revolutService );
  dataSourceNotLinked = new MultiCrudDataSource( this.revolutService );

  columnsNotLinked  = [
    { columnDef: 'targetType', header: 'T', cell: ( row: RevolutTransactionLeg ) => `${ row.targetTypeName }` },
    { columnDef: 'transactionDate', header: 'Date', cell: ( row: RevolutTransactionLeg ) => `${ toDateString( row.transactionDate ) || '' }` },
    // { columnDef: "account", header: "Acc", cell: ( row: RevolutTransactionLeg ) => `${ row.accountId || "" }` },
    { columnDef: 'description', header: 'Description', cell: ( row: RevolutTransactionLeg ) => {
      let ret = '';
      if ( row.isCulpaLawyer ) {
ret += '💼';
} else if ( row.isCulpa ) {
ret += '🕵️‍♂️';
}

      ret += row.description || '';
      if ( !row.description ) {
ret+= row.counterAccountName;
}

      return ret;
      }
    },
    { columnDef: 'reference', header: 'Reference', cell: ( row: RevolutTransactionLeg ) => `${ row.reference || '' }` },
    { columnDef: 'amount', header: 'Amount', cell: ( row: RevolutTransactionLeg ) => `${ row.amount || '' }` },

    { columnDef: 'InvoiceFound1', header: 'Invoice 1', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound == null ? '' : row.invoiceFound.code }` },
    { columnDef: 'InvoiceFound2', header: 'Invoice 2', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound2 == null ? '' : row.invoiceFound2.code  }` },
    { columnDef: 'InvoiceFound3', header: 'Invoice 3', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound3 == null ? '' : row.invoiceFound3.code  }` },
    { columnDef: 'invoiceFound4', header: 'Invoice 4', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound4 == null ? '' : row.invoiceFound4.code  }` },
  ];

  columns = [
    { columnDef: 'targetType', header: 'T', cell: ( row: RevolutTransactionLeg ) => `${ row.targetTypeName }` },
    { columnDef: 'transactionDate', header: 'Date', cell: ( row: RevolutTransactionLeg ) => `${ toDateString( row.transactionDate ) || '' }` },
    // { columnDef: "account", header: "Acc", cell: ( row: RevolutTransactionLeg ) => `${ row.accountId || "" }` },
    { columnDef: 'description', header: 'Description', cell: ( row: RevolutTransactionLeg ) => {
        let ret = '';
        if ( row.isCulpaLawyer ) {
ret += '💼';
} else if ( row.isCulpa ) {
ret += '🕵️‍♂️';
}
        ret += row.description || '';
        return ret;
      }
    },
    { columnDef: 'reference', header: 'Reference', cell: ( row: RevolutTransactionLeg ) => `${ row.reference || '' }` },
    { columnDef: 'amount', header: 'Amount', cell: ( row: RevolutTransactionLeg ) => `${ row.amount || '' }` },

    { columnDef: 'InvoiceFound1', header: 'Invoice 1', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound == null ? '' : row.invoiceFound.code }` },
    { columnDef: 'InvoiceFound2', header: 'Invoice 2', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound2 == null ? '' : row.invoiceFound2.code  }` },
    { columnDef: 'InvoiceFound3', header: 'Invoice 3', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound3 == null ? '' : row.invoiceFound3.code  }` },
    { columnDef: 'invoiceFound4', header: 'Invoice 4', cell: ( row: RevolutTransactionLeg ) => `${ row.invoiceFound4 == null ? '' : row.invoiceFound4.code  }` },
  ];

  search( str: string ) {
    this.table.filters.str = str;
    this.onSearch();
  }

  clearFilterTableNotLinked(){
    //console.log("sdsdsd");
    this.tableNotLinked.clearFilter(true);

  }

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.table.applyFilter();
    }
  }

  searchNotLinked( str: string ) {
    this.tableNotLinked.filters.str = str;
    this.tableNotLinked.filters.someAdditionalData = 'notlinked';
    this.onSearch();
  }

  onSearchNotLinked( isInvalid = false ) {
    if ( !isInvalid ) {
      this.tableNotLinked.filters.someAdditionalData = 'notlinked';
      this.tableNotLinked.applyFilter();
    }
  }


  currentUserIsAdmin(){
    return this.roleService.hasRoles('admin');
  }


  getViewLinkNotLinked = (item: RevolutTransactionLeg): string => item.id.toString()+'/not-linked';

  getViewLink = (item: RevolutTransactionLeg): string => item.id.toString()+'/linked';

}
